module.exports = __webpack_public_path__ + "img/collection-engagementRingsLabGrownDiamonds.670cac6.jpg";